var dependencies;
var script = document.getElementById("survey-script");
if (script) {
  // script might not be defined if we are running tests
  dependencies = script.getAttribute("dependencies");
  if (dependencies) {
    dependencies = dependencies.split(",");
  }
}
angular.module("survey", dependencies || []).config(["$compileProvider", config])

function config($compileProvider) {
  if (
      window.location.hostname !== "127.0.0.1" && 
      window.location.hostname !== "localhost"
      ) {
    $compileProvider.debugInfoEnabled(false);
  }
}